import { ComponentDataSourceService } from '../../component-data-source.service';
import { DataSourceFunction } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../../environment/environment';
import { AuthService } from '../../../auth/auth.service';

/** Same roles as canAddEvents / GET /events/price-groups / GET /events/org-resources. */
const ALLOWED_ROLES = new Set(['superadmin', 'orgadmin', 'orgbruger', 'uddansvarlig']);

/**
 * Visibility for organization resource picker on add/edit event forms.
 */
export function event_org_resources_field_visible(
  service: ComponentDataSourceService
): DataSourceFunction {
  return {
    name: 'event_org_resources_field_visible',
    description:
      'Show org resource field for event creators when org has active bookable resources.',
    execute: (_params?: LoadDataParams): Observable<{ visible: boolean }> => {
      const auth = service.injector.get(AuthService);
      const roles = auth.getUserRoles().map((r) => r.toLowerCase());
      const allowed = roles.some((r) => ALLOWED_ROLES.has(r));
      if (!allowed) {
        return of({ visible: false });
      }

      return service.http
        .get<{ items?: unknown[]; totalCount?: number }>(`${environment.apiUrl}/events/org-resources`, {
          params: { activeOnly: 'true' },
        })
        .pipe(
          map((res) => {
            const count = res?.totalCount ?? res?.items?.length ?? 0;
            return { visible: count > 0 };
          }),
          catchError(() => of({ visible: false }))
        );
    },
  };
}
